import React from 'react';
import Icon from '../../../components/dashboard/DashboardIcons';

const CARDS = [
  { key: 'total', label: 'إجمالي اللاعبين', icon: 'users', accent: 'text-slate-900' },
  { key: 'active', label: 'اللاعبون النشطون', icon: 'check', accent: 'text-teal-700' },
  { key: 'sub_active', label: 'الاشتراكات الفعالة', icon: 'banknotes', accent: 'text-teal-700' },
  { key: 'sub_pending', label: 'بانتظار الدفع', icon: 'warning', accent: 'text-amber-600' },
  { key: 'sub_expiring', label: 'تنتهي قريباً', icon: 'clock', accent: 'text-amber-600' },
  { key: 'sub_expired', label: 'الاشتراكات المنتهية', icon: 'x', accent: 'text-red-600' },
];

export default function PlayerKpiBar({ metrics, onSelect }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-testid="players-kpi-bar">
      {CARDS.map((c) => (
        <button
          key={c.key}
          onClick={() => onSelect(c.key)}
          className="min-h-[88px] rounded-xl border border-slate-200 bg-white p-3 text-right transition-colors hover:border-teal-300"
          data-testid={`players-kpi-${c.key}`}
        >
          <div className="flex items-center justify-between">
            <span className="text-xs text-slate-500">{c.label}</span>
            <Icon name={c.icon} className="w-4 h-4 shrink-0 text-slate-400" />
          </div>
          <div className={`mt-1 text-xl font-bold ${c.accent}`}>{metrics[c.key] ?? 0}</div>
        </button>
      ))}
    </div>
  );
}
